// extracted by mini-css-extract-plugin
export default {"color_field":"PaletteColor_color_field__KVD6o","selected":"PaletteColor_selected__Cw2J8"};